import React from 'react';
import { PortCallsPage as SharedPortCallsPage } from '../../port-calls';

/** Module-scoped spares port calls (tree filtered to spares only). */
export const PortCallsPage: React.FC = () => <SharedPortCallsPage scope="spares" />;

export default PortCallsPage;
